<template>
  <top-view>
    <v-card id="cardView" class="mx-auto" :elevation="0" outlined>
      <v-row class="fill-height mr-0 " max-height="100%">
        <v-list-item id="listItem">
          <v-list-item-content style="height: 100%; margin: -1px -12px 0px 0px">
            <div id="flex-container">
              <div style="height: 70px">
                <div class="iconTopHeader" style="height: 30px; margin: 0px 15px 0 5px;">
                  <v-icon
                    v-on:click="backClicked"
                    class="icon-left"
                    color="black"
                    size="20"
                    style="padding: 10px"
                    >mdi-keyboard-backspace</v-icon
                  >
                  <div v-if="isShowMonthYear()"
                    class=""
                    style="
                      -webkit-text-stroke: 0.5px black;
                      text-transform: uppercase;
                      color: black;
                      font-size: 16px;
                      font-family: 'Open Sans';
                      font-weight: bold;
                    "
                  >
                    <span>{{ monthYear }}</span>
                  </div>
                  <img
                    v-on:click="createVacation"
                    class="icon-right"
                    src="@/assets/icon-calendar.png"
                    width="30px"
                  />
                </div>
                <div
                  style="
                    justify-content: center;
                    display: flex;
                    align-items: center;
                  "
                >
                  <tab-item
                    :tabName="tab"
                    class="btnLeftTab"
                    v-on:tabItemClicked="handleTabItemClick"
                    v-for="tab in tabHeaders"
                    v-bind:key="tab"
                    v-bind:showThisTabItem="tab == activedTab"
                  ></tab-item>
                </div>
              </div>
              <tab-header
                id="tabHeader"
                v-on:createNewVacation="createVacation"
              ></tab-header>
              <div
                id="content"
                class="content-sp"
                style="background: white; margin-top: 12px;"
                :style="contentStyle"
              >
                <component
                  v-bind:is="selectedTabComponent"
                  :showErrorView="showErrorView"
                ></component>
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-row>
    </v-card>
  </top-view>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import TopView from "../../commonui/topView/TopView";
import TabItem from "../../commonui/TabItem";
import TabHeader from "../../home/TabHeader";
import TabMyList from "../../home/TabMyList";
import TabRequesting from "../../home/TabRequesting";
import TabAll from "../../home/TabAll";
import {
  ListEvents,
  TabNames,
  ScreenNames,
} from "@/utilities/CommonUtilities";

export default {
  components: { TopView, TabItem, TabHeader, TabAll, TabMyList, TabRequesting },
  data() {
    return {
      userInfomation: {},
      showErrorView: false,
      tabHeaders: [],
      activedTab: "",
    };
  },
  mounted() {
    this.notifyBus.$on(ListEvents.changeTabName, (tabName) => {
      let requestingTitle = this.$i18n.t("tab_inprogress_list");
      let approvedListTitle = this.$i18n.t("tab_approved_list");
      let myListTitle = this.$i18n.t("tab_my_list");
      if (tabName === TabNames.All) {
          this.tabHeaders = [approvedListTitle, requestingTitle];
      } else {
          this.tabHeaders = [myListTitle, requestingTitle];
      }
      this.activedTab = this.tabHeaders[0];
    });
  },
  computed: {
    ...mapGetters(["getUserByID"]),
    ...mapState(["userInfo"]),
    ...mapState({
      currentTab: (state) => state.homeData.currentTab,
      selectedTab: (state) => state.homeData.selectedTab,
    }),
    ...mapGetters({
      filterCalendar: "homeData/getFilterInfo",
    }),
    monthYear() {
      let filterInfoTemp = this.filterCalendar.dateChoosed;
      const date = new Date(filterInfoTemp);

      const options = filterInfoTemp.includes('-') && filterInfoTemp.split('-').length === 3
        ? { day: "numeric", month: "short", year: "numeric" }
        : { month: "short", year: "numeric" };
      return date.toLocaleDateString(this.$i18n.locale, options);
    },
    selectedTabComponent() {
      if (this.selectedTab === TabNames.Requesting) {
        return TabRequesting;
      } else {
        if (this.currentTab === TabNames.MyList) {
          return TabMyList;
        } else {
          return TabAll;
        }
      }
    },
    contentStyle() {
      if (this.selectedTabComponent === TabRequesting) {
        return { height: "80vh" };
      } else {
        return { height: "70vh" };
      }
    },
  },
  created() {
    this.initTabHeader();
  },
  methods: {
    ...mapMutations({
      setSelectedTab: "homeData/setSelectedTab",
      setCurrentTab: "homeData/setCurrentTab",
      setCurrentScreen: "homeData/setCurrentScreen",
      saveFilter: "homeData/saveFilter",
      setSelectedDate: "homeData/setSelectedDate",
    }),
    initTabHeader() {
      let myListTitle = this.$i18n.t("tab_my_list");
      let requestingTitle = this.$i18n.t("tab_inprogress_list");
      let approvedListTitle = this.$i18n.t("tab_approved_list");
        this.tabHeaders =
          this.currentTab === TabNames.All
            ? [approvedListTitle, requestingTitle]
            : [myListTitle, requestingTitle];
      this.activedTab = this.getSelectedTab();
    },
    editProfile() {
      this.$router.push("/editprofile/" + this.userInfo.userID);
    },
    createVacation() {
      let filterInfoTemp = this.filterCalendar.dateChoosed;
      this.setCurrentScreen(ScreenNames.ListVacation);
      this.setSelectedDate(filterInfoTemp);
      this.$router.push({
        name: "applyVacation",
        params: { option: "create" },
      });
    },
    backClicked() {
      let filterInfoTemp = this.filterCalendar;
      filterInfoTemp.searchName = "";
      this.saveFilter(filterInfoTemp);
      this.setCurrentScreen(ScreenNames.Calendar);
      this.$router.push({ name: "home" });
    },
    getSelectedTab() {
      return this.selectedTab === TabNames.All
        ? this.tabHeaders[0]
        : this.tabHeaders[1];
    },
    handleTabItemClick(tabName) {
      this.tabItemClicked(tabName);
    },
    tabItemClicked(tabName) {
      this.activedTab = tabName;
      var selectingTabName = TabNames.All;
      let index = this.tabHeaders.findIndex((p) => p == tabName);
      if (index == this.tabHeaders.length - 1 ) {
        selectingTabName = TabNames.Requesting;
      }
      this.setSelectedTab(selectingTabName);
    },
    isShowMonthYear(){
      return this.activedTab === 'Approved List' || this.activedTab === 'My List';
    }
  },
  inject: ["notifyBus"],
  provide: function () {
    return {
      homeViewBus: this.localBus,
    };
  },
  beforeDestroy() {
    this.notifyBus.$off(ListEvents.changeTabName);
  },
};
</script>
<style scoped>
.btnLeftTab {
  width: 100%;
  font-size: 16px;
  font-weight: 900;
}
.btnLeftTab:focus {
  outline: 0;
}

::v-deep .dynamic-component-tab-button {
  width: 100%;
}
::v-deep .dynamic-component-tab-button.dynamic-component-tab-button-active {
  width: 100%;
}
.v-list-item {
  padding: 0 12px;
}
.content-sp {
  padding-left: 10px !important;
}
#content {
  width: 100%;
  object-fit: cover;
  overflow-x: hidden;
  overflow-y: scroll;
  text-align: justify;
}
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

#content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.iconTopHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#tabHeader .demo {
  padding-bottom: 10px;
  margin-bottom: -12px !important;
}
</style>